import React, { FunctionComponent } from 'react';
import BaseCard from '@/components/layout/landingPages/cards/BaseCard';
import BaseCardTextHeader from '@/components/layout/landingPages/cards/BaseCardTextHeader';
import Header from '@/components/typography/Header';
import BaseCardBody from '@/components/layout/landingPages/cards/BaseCardBody';
import { IPrismicRichTextElement } from '@/pageGeneration/services/prismicApi/types';
import PrismicRichText from '@/components/design/PrismicRichText';

interface IProps {
  type: 'primary' | 'secondary';
  content: IPrismicRichTextElement[];
  title: string;
}

const StaticCopyCard: FunctionComponent<IProps> = ({ title, content, type }) => (
  <BaseCard type={type}>
    <BaseCardTextHeader>
      <Header level={5} color={type} strong marginBottom={0}>
        {title}
      </Header>
    </BaseCardTextHeader>
    <BaseCardBody>
      <PrismicRichText items={content} />
    </BaseCardBody>
  </BaseCard>
);

export default StaticCopyCard;
